import { Toaster } from '../components/ui/sonner';
import { AppProvider } from './provider';
import { AppRouter } from './router';

export const App = () => {
  return (
    <AppProvider>
      <AppRouter />
      <Toaster position="top-center" />
    </AppProvider>
  );
};
